import { ComponentType, FC } from 'react';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { IWithAuthenticatedStatusProps as IProps } from './types';

export const withAuthenticatedStatus = <P extends object>(
  WrappedComponent: ComponentType<P & IProps>,
): FC<P> => {
  const WithAuthenticatedStatus: FC<P> = (props) => {
    const { isAuthenticated, isAuthConfiguring } = useAuthenticated();

    return <WrappedComponent {...(props as P)} isAuth={isAuthenticated || isAuthConfiguring} />;
  };

  return WithAuthenticatedStatus;
};
